<template>
  <h1>Error 404: Problème de connexion à l'API</h1>
</template>

<script>
export default {
  computed: {
    apiBackup() {
      return this.$store.getters.isProductsLoaded();
    },
  },
  watch: {
    apiBackup() {
      if (this.$store.getters.isProductsLoaded()) {
        this.$router.push('/');
      }
    },
  },
};
</script>
